export function SharePopup({url, text, configuration, objectId}) {
    const content_type = configuration.content_type;
    const object_id = objectId || configuration.object_id;

  const shareFacebook = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=facebook&content_type=${content_type}&object_id=${object_id}`;
    const shareTwitter = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=twitter&content_type=${content_type}&object_id=${object_id}`;
    const shareWhatsApp = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=whatsapp&content_type=${content_type}&object_id=${object_id}`;
    const shareTelegram = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=telegram&content_type=${content_type}&object_id=${object_id}`;
    const shareEmail = `mailto:?subject=${text}&body=${window.location.protocol}//${window.location.hostname}${url}`;
    let mobile = '';
    if ( window.navigator.userAgent.search('Mobile') >= 0) {
        mobile = <a className="WhatsApp" href={shareWhatsApp}
            target="blank"
            title="WhatsApp">
        </a>
    }
    function click (event) {
        event.target.closest('.share-modal').classList.remove('visible');
    }
    return <div className="share-modal">
      <div className="modal-content">
        <span className="share-close" onClick={click}>
            <i className="icon-cruz"></i>
        </span>

        <div id="share-url-wrapper">
            <p>{configuration.translations.shareMenuTitle}</p>
            <div className="share-icons">
                <a className="Facebook" href={shareFacebook}
                    target="blank"
                    title="FaceBook">
                </a>
                <a className="X" href={shareTwitter}
                    target="blank"
                    title="X">
                </a>
                {mobile}
                <a className="Telegram" href={shareTelegram}
                    target="blank"
                    title="Telegram">
                </a>
                <a className="Email" href={shareEmail}
                    target="blank"
                    title="By Email">
                </a>
            </div>
        </div>
      </div>
    </div>
}
